/** The eligibility task list. */
export const ELIGIBILITY_TASKS_PATH = '/eligibility/tasks';

/** An eligibility task's detail page. The path holds only the opaque task id. */
export const getEligibilityTaskUrl = (taskId: number | string): string =>
  `${ELIGIBILITY_TASKS_PATH}/${taskId}/show`;
